<template>
  <div class="pillbox-page">
    <!-- KPI 卡片 -->
    <div class="kpi-row">
      <div class="kpi-card">
        <div class="kpi-icon kpi-blue">&#9632;</div>
        <div class="kpi-info">
          <div class="kpi-label">设备总数</div>
          <div class="kpi-value">{{ stats.total }}<span class="kpi-unit">台</span></div>
          <div class="kpi-sub">在线率 {{ stats.onlineRate }}%</div>
        </div>
      </div>
      <div class="kpi-card">
        <div class="kpi-icon kpi-green">&#9632;</div>
        <div class="kpi-info">
          <div class="kpi-label">在线设备</div>
          <div class="kpi-value" style="color:#67c23a">{{ stats.online }}<span class="kpi-unit">台</span></div>
        </div>
      </div>
      <div class="kpi-card">
        <div class="kpi-icon kpi-orange">&#9632;</div>
        <div class="kpi-info">
          <div class="kpi-label">今日服药</div>
          <div class="kpi-value">{{ stats.todayTake }}<span class="kpi-unit">次</span></div>
          <div class="kpi-sub">依从率 {{ stats.compliance }}%</div>
        </div>
      </div>
      <div class="kpi-card">
        <div class="kpi-icon kpi-red">&#9632;</div>
        <div class="kpi-info">
          <div class="kpi-label">今日漏服</div>
          <div class="kpi-value" style="color:#f56c6c">{{ stats.todayMiss }}<span class="kpi-unit">次</span></div>
        </div>
      </div>
    </div>

    <!-- 筛选栏 -->
    <div class="filter-bar">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="老人姓名">
          <el-input v-model.trim="formInline.oldmanName" placeholder="请输入姓名" clearable style="width:140px" />
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model.trim="formInline.deviceNo" placeholder="如 XS542382" clearable style="width:140px"
            @keyup.enter.native="loadList" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="loadList">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button type="success" icon="el-icon-plus" @click="openAddDialog">新增设备</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div v-loading="loading" element-loading-text="加载中...">
      <el-table :data="list" style="width:100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor" border>
        <el-table-column label="老人 / 设备" min-width="160">
          <template slot-scope="scope">
            <div style="display:flex;align-items:center;gap:8px">
              <div class="avatar">{{ scope.row.oldmanName ? scope.row.oldmanName.charAt(0) : '?' }}</div>
              <div>
                <div style="font-weight:500">{{ scope.row.oldmanName || '未绑定' }}</div>
                <div style="font-size:12px;color:#909399">{{ scope.row.deviceNo }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="绑定位置" prop="location" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.location" size="mini">{{ scope.row.location }}</el-tag>
            <el-tag v-else size="mini" type="warning">未设置</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="在线状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.onlineStatus === 1 ? 'success' : 'info'" size="mini">
              {{ scope.row.onlineStatus === 1 ? '在线' : '离线' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="电量" width="80" align="center">
          <template slot-scope="scope">
            <span :style="{ color: getBatteryColor(scope.row.battery) }">
              {{ scope.row.battery != null ? scope.row.battery + '%' : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="信号" width="70" align="center">
          <template slot-scope="scope">{{ getSignalLabel(scope.row.signalStrength) }}</template>
        </el-table-column>
        <el-table-column label="固件版本" prop="firmwareVersion" width="100" align="center" />
        <el-table-column label="最后上报" width="160" align="center">
          <template slot-scope="scope">
            <span style="font-size:12px;color:#909399">{{ scope.row.lastReportTime || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="配置状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="getSendStatusType(scope.row.sendStatus)" size="mini">
              {{ getSendStatusLabel(scope.row.sendStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="230" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="success" size="mini" plain @click="goConfig(scope.row)">配置</el-button>
            <el-button type="primary" size="mini" plain @click="goRecord(scope.row)">记录</el-button>
            <el-button :type="scope.row.isBound ? 'warning' : 'primary'" size="mini" plain
              @click="handleBindOrUnbind(scope.row)">
              {{ scope.row.isBound ? '解绑' : '绑定' }}
            </el-button>
            <el-popconfirm v-if="!scope.row.isBound" title="确认删除此设备？" @confirm="handleDelete(scope.row)">
              <el-button slot="reference" type="danger" size="mini" plain>删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination background layout="total, prev, pager, next" :total="total" :page-size="pageSize"
        :current-page="pageNum" @current-change="handlePageChange" class="fenye" />
    </div>

    <!-- 新增设备弹窗 -->
    <el-dialog title="新增设备" :visible.sync="addVisible" width="400px">
      <el-form :model="addForm" label-width="90px">
        <el-form-item label="设备编号" required>
          <el-input v-model="addForm.deviceNo" placeholder="2位字母+6位数字，如 XS542382" />
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="addForm.deviceName" placeholder="如：301室药盒" />
        </el-form-item>
        <el-form-item label="设备描述">
          <el-input v-model="addForm.remark" placeholder="选填" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click="handleAdd">确定</el-button>
      </span>
    </el-dialog>

    <!-- 绑定老人弹窗 -->
    <el-dialog title="绑定老人" :visible.sync="bindVisible" width="400px">
      <el-form :model="bindForm" label-width="90px">
        <el-form-item label="设备编号">
          <el-input :value="bindForm.deviceNo" disabled />
        </el-form-item>
        <el-form-item label="选择老人" required>
          <el-select v-model="bindForm.oldmanId" placeholder="输入姓名搜索" filterable remote
            :remote-method="searchOldman" style="width:100%">
            <el-option v-for="item in oldmanOptions" :key="item.oldmanId" :value="item.oldmanId"
              :label="item.oldName" />
          </el-select>
        </el-form-item>
        <el-form-item label="安装位置">
          <el-input v-model="bindForm.location" placeholder="如：301室" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="bindVisible = false">取消</el-button>
        <el-button type="primary" :loading="bindLoading" @click="handleBind">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bus from "@/vuex/eventBus";

export default {
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      formInline: { oldmanName: '', deviceNo: '' },
      stats: { total: 0, online: 0, onlineRate: 0, todayTake: 0, todayMiss: 0, compliance: 0 },
      // 新增
      addVisible: false,
      addLoading: false,
      addForm: { deviceNo: '', deviceName: '', remark: '' },
      // 绑定
      bindVisible: false,
      bindLoading: false,
      bindForm: { oldmanId: undefined, deviceNo: '', location: '' },
      oldmanOptions: [],
    };
  },
  methods: {
    loadList() {
      this.loading = true;
      this.$postJson('dmc/medicineBox/queryDeviceListWithPage', {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        oldmanName: this.formInline.oldmanName || undefined,
        deviceNo: this.formInline.deviceNo || undefined,
      }).then(res => {
        const data = res.result || res;
        this.list = data.list || [];
        this.total = Number(data.total) || 0;
      }).finally(() => { this.loading = false; });

      this.$postJson('dmc/medicineBox/todayStats', {}).then(res => {
        const data = res.result || res;
        if (data) Object.assign(this.stats, data);
      });
    },
    resetForm() {
      this.formInline = { oldmanName: '', deviceNo: '' };
      this.pageNum = 1;
      this.loadList();
    },
    handlePageChange(val) {
      this.pageNum = val;
      this.loadList();
    },
    // 新增设备
    openAddDialog() {
      this.addForm = { deviceNo: '', deviceName: '', remark: '' };
      this.addVisible = true;
    },
    handleAdd() {
      if (!this.addForm.deviceNo) { this.$message.warning('请输入设备编号'); return; }
      if (!/^[A-Za-z]{2}\d{6}$/i.test(this.addForm.deviceNo)) {
        this.$message.warning('设备编号格式错误，应为2位字母+6位数字'); return;
      }
      this.addLoading = true;
      this.$postJson('dmc/commonDevice/add', {
        deviceNo: this.addForm.deviceNo.toUpperCase(),
        deviceName: this.addForm.deviceName || this.addForm.deviceNo.toUpperCase(),
        remark: this.addForm.remark,
        deviceType: 43,
      }).then(res => {
        if (res && res.code == 200) {
          this.$message.success('新增成功');
          this.addVisible = false;
          this.loadList();
        }
      }).finally(() => { this.addLoading = false; });
    },
    // 绑定/解绑
    handleBindOrUnbind(row) {
      if (row.isBound) {
        this.$confirm('确认解绑该设备？', '提示', { type: 'warning' }).then(() => {
          this.$postJson(`dmc/medicineBox/unbindDevice/${row.id}`, {}).then(res => {
            if (res && res.code == 200) { this.$message.success('解绑成功'); this.loadList(); }
          });
        }).catch(() => {});
      } else {
        this.bindForm = { oldmanId: undefined, deviceNo: row.deviceNo, location: '' };
        this.oldmanOptions = [];
        this.bindVisible = true;
      }
    },
    searchOldman(keyword) {
      if (!keyword) return;
      this.$postJson('omc/Oldman/quickShowOldMan', { oldName: keyword, pageNo: '1', pageSize: '20' }).then(res => {
        const data = res.result || res;
        this.oldmanOptions = data.list || (data.result && data.result.list) || [];
      });
    },
    handleBind() {
      if (!this.bindForm.oldmanId) { this.$message.warning('请选择老人'); return; }
      this.bindLoading = true;
      this.$postJson('dmc/medicineBox/bindDevice', {
        oldmanId: this.bindForm.oldmanId,
        deviceNo: this.bindForm.deviceNo.toUpperCase(),
        location: this.bindForm.location,
      }).then(res => {
        if (res && res.code == 200) {
          this.$message.success('绑定成功');
          this.bindVisible = false;
          this.loadList();
        }
      }).finally(() => { this.bindLoading = false; });
    },
    handleDelete(row) {
      this.$postJson(`dmc/medicineBox/deleteDevice/${row.id}`, {}).then(res => {
        if (res && res.code == 200) { this.$message.success('删除成功'); this.loadList(); }
      });
    },
    // 跳转
    goConfig(row) {
      bus.$emit("homePage", {
        type: "jump", path: "/SmartPillboxSetting", title: '服药提醒配置',
        params: { deviceId: row.id, deviceNo: row.deviceNo, oldmanName: row.oldmanName }
      });
    },
    goRecord(row) {
      bus.$emit("homePage", {
        type: "jump", path: "/SmartPillboxData", title: '服药记录',
        params: { deviceNo: row.deviceNo, oldmanName: row.oldmanName }
      });
    },
    // 工具函数
    getBatteryColor(v) {
      if (v == null) return '#909399';
      return v <= 20 ? '#f56c6c' : v <= 50 ? '#e6a23c' : '#67c23a';
    },
    getSignalLabel(v) {
      if (v == null) return '-';
      return v <= 5 ? '极弱' : v <= 10 ? '弱' : v <= 20 ? '中' : '强';
    },
    getSendStatusLabel(v) {
      return { 0: '未配置', 1: '已下发', 2: '下发失败', 3: '已确认' }[v] || '-';
    },
    getSendStatusType(v) {
      return { 0: 'info', 1: 'warning', 2: 'danger', 3: 'success' }[v] || 'info';
    },
    tableRowStyle({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'background:#fff' : 'background:#e4f5f8';
    },
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) return 'color:#2d2d2d;font-weight:600;font-size:14px;background:#d4f5fa;';
    },
  },
  created() {
    this.loadList();
  },
};
</script>

<style lang="scss" scoped>
.pillbox-page { padding: 10px 5px; }

.kpi-row {
  display: flex; gap: 12px; margin-bottom: 16px; flex-wrap: wrap;
}
.kpi-card {
  flex: 1; min-width: 160px;
  display: flex; align-items: center; gap: 12px;
  padding: 14px 18px;
  background: #fff; border-radius: 6px; border: 1px solid #ebeef5;
  box-shadow: 0 1px 4px rgba(0,0,0,.06);
}
.kpi-icon {
  width: 38px; height: 38px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 16px; flex-shrink: 0;
}
.kpi-blue   { background: #ecf5ff; color: #409eff; }
.kpi-green  { background: #f0f9eb; color: #67c23a; }
.kpi-orange { background: #fdf6ec; color: #e6a23c; }
.kpi-red    { background: #fef0f0; color: #f56c6c; }
.kpi-label  { font-size: 12px; color: #909399; }
.kpi-value  { font-size: 24px; font-weight: 700; color: #303133; line-height: 1.2; }
.kpi-unit   { font-size: 12px; font-weight: 400; color: #909399; margin-left: 2px; }
.kpi-sub    { font-size: 11px; color: #909399; margin-top: 2px; }

.filter-bar { margin-bottom: 12px; }

.avatar {
  width: 30px; height: 30px; border-radius: 50%;
  background: #ecf5ff; color: #409eff;
  display: flex; align-items: center; justify-content: center;
  font-size: 13px; font-weight: 600; flex-shrink: 0;
}

.fenye { margin: 20px 0; text-align: right; }
</style>
